module.exports = __webpack_public_path__ + "img/image8.d30d4429.png";